import { Flag } from '@mui/icons-material';
import { Avatar, Box, Button, Tooltip } from '@mui/material';
import { Dropdown, Nav, NavLink } from 'react-bootstrap';
import { getLatestIteration } from '../../../lib/utils';
import SkeletonLoader from '../../elements/SkeletonLoader';

const TestPlayerSidebar = ({
  testCases,
  activeTab,
  handleTabClick,
  users,
  loading,
  viewMode,
  handleViewModeChange,
  iterations,
  getIterationsByTestCycleId,
  loadMoreTestCases,
  hasMoreTestCases,
}) => {
  const getDisplayName = (accountId) => {
    const user = users.find((user) => user?.accountId === accountId);
    return user ? user.displayName : accountId;
  };
  const latestIteration = getLatestIteration(iterations);

  return (
    <div className="mb-3 test-player-sidebar">
      <div className="group-by-container">
        <span className="text-muted" style={{ fontSize: '14px' }}>
          Group By:
        </span>
        <Dropdown>
          <Dropdown.Toggle
            variant="light"
            className="text-muted"
            style={{ fontSize: '16px', padding: '2px 8px' }}>
            {viewMode === 'iterations'
              ? `Iterations`
              : `Test Cases`}
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item
              active={viewMode === 'iterations'}
              onClick={() => handleViewModeChange('iterations')}>
              Iterations
            </Dropdown.Item>
            <Dropdown.Item
              active={viewMode === 'testcases'}
              onClick={() => handleViewModeChange('testcases')}>
              Test Cases
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
      {loading && testCases.length === 0 ? (
        <SkeletonLoader />
      ) : viewMode === 'testcases' ? (
        <>
          {testCases?.map(({ testcase, assigned_to, id }) => (
            <Nav.Item key={id} className="mb-2">
              <Tooltip title={testcase?.summary || ''} arrow placement="right">
                <NavLink
                  as="div"
                  onClick={() => handleTabClick(id, testcase)}
                  style={{
                    textDecoration: 'none',
                    padding: '10px',
                    borderRadius: '5px',
                    backgroundColor: activeTab === id ? '#e0dcdc' : '#fff',
                    border: '1px solid #ddd',
                    width: '90%',
                    cursor: 'pointer',
                  }}>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <Flag sx={{ color: testcase?.priority_details?.color }} />
                      <strong style={{ fontSize: '1.1em', marginLeft: '10px' }}>
                        {testcase?.key}
                      </strong>
                    </div>
                    <Avatar
                      sx={{ width: 24, height: 24, fontSize: '0.8rem' }}
                      title={getDisplayName(assigned_to) || 'GAINSS'}>
                      {getDisplayName(assigned_to)?.[0] || 'G'}
                    </Avatar>
                  </div>
                </NavLink>
              </Tooltip>
            </Nav.Item>
          ))}
          {hasMoreTestCases && (
            <Box sx={{ textAlign: "left" }}>
              <Button
                variant="text"
                color="primary"
                size="small"
                sx={{
                  p: 0,
                  minWidth: "auto",
                  textTransform: "none",
                }}
                onClick={loadMoreTestCases}
                disabled={loading}
              >
                {loading ? "Loading More..." : "Show More"}
              </Button>
            </Box>
          )}
        </>
      ) : (
        iterations.map((iteration) => (
          <Nav.Item key={iteration.id} className="mb-2">
            <NavLink
              as="div"
              onClick={() => handleTabClick(iteration.id)}
              style={{
                textDecoration: 'none',
                padding: '10px',
                borderRadius: '5px',
                backgroundColor:
                  activeTab === iteration.id ? '#e0dcdc' : iteration.is_closed ? '#ffcccc' : '#fff',
                border: '1px solid #ddd',
                width: '90%',
                cursor: 'pointer',
              }}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}>
                {/* Iteration Name + New Badge */}
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    minWidth: 0,
                  }}>
                  <div
                    style={{
                      fontSize: '0.9em',
                      color: '#555',
                      maxWidth: 180,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                    title={iteration?.name}>
                    {iteration?.name}
                  </div>
                  {latestIteration?.id === iteration.id && (
                    <span
                      title="Latest Iteration"
                      style={{
                        backgroundColor: '#007bff',
                        color: '#fff',
                        padding: '2px 4px',
                        borderRadius: '3px',
                        fontSize: '0.6em',
                        marginLeft: '8px',
                        whiteSpace: 'nowrap',
                      }}>
                      New
                    </span>
                  )}
                </div>
                <Avatar
                  sx={{
                    width: 24,
                    height: 24,
                    fontSize: '0.8rem',
                    marginLeft: '10px',
                  }}
                  title={getDisplayName(iteration.executed_by) || 'GAINSS'}>
                  {getDisplayName(iteration.executed_by)?.[0] || 'G'}
                </Avatar>
              </div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  marginTop: '6px',
                }}>
                <div
                  style={{
                    fontSize: '12px',
                    color: '#6b6b6b',
                    maxWidth: '250px',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}
                  title={iteration?.environment_details?.name}>
                  {iteration?.environment_details?.name} {iteration?.country?.length > 0 && `| ${iteration?.country?.join(', ')}`}
                </div>
              </div>
            </NavLink>
          </Nav.Item>
        ))
      )}
    </div>
  );
};

export default TestPlayerSidebar;
